// removed by extract-text-webpack-plugin
module.exports = {"base":"Unit_base--2Vr51","battleMode":"Unit_battleMode--1hh4w","counter":"Unit_counter--3bSbz","inBattle":"Unit_inBattle--3xny0","highlight":"Unit_highlight--tuhHi","commanderName":"Unit_commanderName--2W6Tn"};


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/containers/PlayersMatchingView/components/Unit/Unit.scss
// module id = 471
// module chunks = 11 12